import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-arrow-down\">\n    <path d=\"M11.25 3V18.0469L6.16406 12.9609L5.08594 14.0391L11.4609 20.4141L12 20.9297L12.5391 20.4141L18.9141 14.0391L17.8359 12.9609L12.75 18.0469V3H11.25Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol